export interface RequestKind {
    url: string,
    method: Method,
    format: Format
}

export enum Method {
    POST = "POST",
    GET = "GET"
}

export enum Format {
    json,
    form,
    blob,
    text
}